import { cn } from '../../lib/cn';
import type { ReconciliationRow } from '../../financialintel/framework';

type Props = { rows?: ReconciliationRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'complete': return 'text-success-600';
    case 'review': return 'text-warning-600';
    case 'in_progress': return 'text-brand-600';
    default: return 'text-slate-500';
  }
}

export function ReconciliationPanel({ rows = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-4">
      {rows.map((r) => (
        <div key={r.type} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{r.type} Reconciliation</p>
          <p className="mt-1 text-2xl font-semibold">{r.matched}%</p>
          <p className="text-xs text-slate-500">{r.exceptions} exceptions</p>
          <p className={cn('mt-1 text-xs font-medium capitalize', statusColor(r.status))}>{r.status.replace('_', ' ')}</p>
        </div>
      ))}
    </div>
  );
}
